









import { Component, Prop, Vue } from "vue-property-decorator";
import store from "./store";

@Component({})
export default class App extends Vue {
  constructor() {
    super();
  }

  created() {
    let uri = window.location.search.substring(1);
    let params = new URLSearchParams(uri);
    var authority = params.get("authority");
    if (authority) {
      store.commit("updateAuthorityName", authority);
    }
    store.dispatch("getSystemData");
  }

  get appEnv() {
    return store.getters.appEnv;
  }
}
